module.exports = __webpack_public_path__ + "img/t1.5f4dbf3f.png";